export default "__VITE_ASSET__abb15a35__"